import { Box, Button, Typography } from '@mui/material';
import ClassIcon from '@mui/icons-material/Class';

export const CategoryListItem = ({ category, onClick }) => {
  const { label, color, icon, projectsCount, VirtualIcon } = category;
  const url = icon?.temporaryUrl;

  return (
    <Button
      onClick={() => onClick(category)}
      variant="contained"
      color="secondary"
      sx={{
        padding: '8px 12px',
        justifyContent: 'flex-start',
        textTransform: 'none',
        border: `1px solid ${color}80`,
      }}
      className="w-full flex flex-row items-center gap-3 backdrop-blur-lg rounded-lg"
    >
      <Box
        className="h-10 w-10 rounded-full flex items-center justify-center shrink-0"
        sx={{ bgcolor: color + '30' }}
      >
        {url ? (
          <img alt="" src={url} className="h-7 w-7 object-contain" />
        ) : VirtualIcon ? (
          <VirtualIcon sx={{ color }} />
        ) : (
          <ClassIcon sx={{ color }} />
        )}
      </Box>
      <Typography
        variant="h5"
        className="grow"
        sx={{
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          whiteSpace: 'normal',
          textAlign: 'left',
        }}
      >
        <b>{label}</b>
      </Typography>
      {projectsCount != null && (
        <Box
          sx={{
            minWidth: '28px',
            height: '24px',
            padding: '0 10px',
            borderRadius: '12px',
            bgcolor: color + '40',
            border: `1px solid ${color}80`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '13px',
            fontWeight: 600,
            shrink: 0,
          }}
          className="shrink-0"
        >
          {projectsCount}
        </Box>
      )}
    </Button>
  );
};
